import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  Card,
  CardNumber,
  CardTitle,
  ProgressBar,
  IntervalSelect,
  SearchBarBox,
  SearchFilterButton,
  Font12pxBold,
  Font12pxRegular,
  Font14pxBold,
  TableCellCondensed,
  Sections,
  CenterPageSection,
  BackButtonContainer,
  MainContainer,
  DetailContainer,
  CardTag,
  StyledTableContainer,
  TableFooterStyled,
} from "./DonationDetail.styles";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PersonIcon from '@mui/icons-material/Person';
import DoubleChevronIcon from "components/icons/DoubleChevronIcon";
import {
  Typography,
  Grid,
  Avatar,
  MenuItem,
  InputBase,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import DonationChart from "./DonationChart";
import ProjectNavBarBack from "components/layout/navigation/ProjectNavBarBack/ProjectNavBarBack";
import { useNavigate, useParams } from "react-router-dom";
import { getCampaignByCampaignShortPOST } from "apis/CampaignServiceApi";
import {
  getDonationHistory,
  getDonationStats,
  getDonorLeaderboard,
} from "apis/DonorServiceApi";
import { CampaignInfo } from "types";
import { fetchCampaignDonors } from "store/campaigns/campaignDonors/campaignDonors.actions";

import DownloadCSVButton from "components/common/DownloadCSVButton";
import TopDonorsList from "components/DonationDetails/TopDonorsList";
import TransactionsTable from "components/DonationDetails/TransactionsTable";

interface Transaction {
  id: number;
  donor_id: number;
  donation_amount: number;
  donation_date: string;
  donation_status: string;
  donor_name: string;
  donor_email: string;
}

interface Donor {
  id: number;
  name: string;
  avatar: string;
  amount: number;
  date: string;
  anon: number;
}

interface DonationStatsTime {
  date: string;
  amount: number;
}

function formatDollarAmount(amount: number): string {
  return "$" + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatDate(date: string): string {
  return new Date(date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
  });
}

function getDaysLeft(dateString: string): number {
  const targetDate = new Date(dateString);
  const currentDate = new Date();
  targetDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  const diffTime = targetDate.getTime() - currentDate.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

const donationStatsTimes = [
  {
    value: "week",
    label: "Week",
  },
  {
    value: "month",
    label: "Month",
  },
  {
    value: "year",
    label: "Year",
  },
];

export default function DonationDetail() {
  const campaingShort = useParams().campaignId;
  const params = useParams()
  console.log("Paams: ", params)

  const navigate = useNavigate();

  const [campaignDetails, setCampaignDetails] = React.useState<CampaignInfo>({
    awards: "",
    created_at: "",
    default_image: "",
    description: "",
    goal: 0,
    id: "",
    location: "",
    name: "",
    short_id: "",
    shortened_location: "",
    status: "",
    total_raised: 0,
    updated_at: "",
    user_id: 0,
    count_donor: 0,
    project_id: 0,
    start_date_time: "",
    end_date_time: "",
  });
  const [transactionData, setTransactionData] = React.useState<any[]>([]);
  const [donationData, setDonationData] = React.useState<number[]>([]);
  const [donationCategories, setDonationCategories] = React.useState<string[]>(
    []
  );
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);
  const [statsTime, setStatsTime] = React.useState<string>("week");
  const [showAllDonors, setShowAllDonors] = React.useState(false);

  const dispatch = useAppDispatch();
  const donorData = useAppSelector(state => state.campaigns.campaignDonors.data);
  React.useEffect(() => {
    getCampaignByCampaignShortPOST({ campaign_short: campaingShort! }).then(
      (response) => {
        if (response.length > 0) {
          setCampaignDetails(response[0]);

          dispatch(fetchCampaignDonors(campaingShort!))
            .unwrap()
            .then(() => {
            })
            .catch((err: unknown) => {
              console.error("Error fetching donors:", err);
            });

          getDonationHistory({ campaign_id: response[0].id }).then(
            (response) => {
              setTransactionData(response);
            }
          );
          handleDonationStats();
        }
      }
    );
  }, []);

  useEffect(() => {
    handleDonationStats();
  }, [statsTime, campaignDetails]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleBackToProjects = () => {
    navigate(-1);
  };

  const handleDonationStats = async () => {
    if (statsTime && campaignDetails.id) {
      getDonationStats({
        campaign_id: campaignDetails.id,
        time: statsTime,
      }).then((response) => {
        console.log(response);
        const values: number[] = Object.values(response.DonationStats);
        const categories: string[] = Object.keys(response.DonationStats);
        setDonationData(values.map((value) => value));
        setDonationCategories(
          categories.map((category) => {
            let [year, month, day] = category.split("-").map(Number);
            let date = day
              ? new Date(year, month - 1, day)
              : new Date(year, month - 1);
            console.log(date);
            if (statsTime === "year") {
              return date.toLocaleDateString("en-US", {
                month: "short",
                year: "numeric",
              });
            } else if (statsTime === "month") {
              return date.toLocaleDateString("en-US", {
                day: "2-digit",
              });
            } else {
              return date.toLocaleDateString("en-US", {
                weekday: "short",
                day: "2-digit",
              });
            }
          })
        );
        console.log(donationCategories);
      });
    }
  };

  const mappedDonors = donorData.map(d => ({
    id: d.id,
    avatar: d.user.socialAvatarUrl,
    name: d.user.name,
    date: d.created_at,
    amount: Number(d.amount),
    isAnonymous: false,
    displayAmount: true,
  }));

  return (
    <Sections>
      <CenterPageSection>
        <MainContainer>
          <BackButtonContainer>
            <ProjectNavBarBack onClick={handleBackToProjects} />
          </BackButtonContainer>
          <DetailContainer>
            <Grid container>
              <Grid item xs={12}>
                <Typography sx={{ fontWeight: "600", fontSize: "30px" }}>
                  {" "}
                  Donation Detail{" "}
                </Typography>
              </Grid>
              <Grid container>
                <Grid item xs={8}>
                  <Grid container columnSpacing={6} rowSpacing={2}>
                    <Grid item xs={3.5}>
                      <Card
                        style={{
                          minHeight: "120px",
                          backgroundColor: "#FDFDFD",
                          borderRadius: 10,
                        }}
                      >
                        <CardTitle style={{ marginLeft: "0.75rem" }}>
                          Days left
                        </CardTitle>
                        <CardNumber>
                          {Math.max(0, getDaysLeft(campaignDetails.end_date_time))}
                        </CardNumber>
                        <CardTag>
                          {formatDate(campaignDetails.start_date_time)} ~{" "}
                          {formatDate(campaignDetails.end_date_time)}
                        </CardTag>
                      </Card>
                    </Grid>
                    <Grid item xs={7.5}>
                      <Card
                        style={{
                          minHeight: "120px",
                          backgroundColor: "#FDFDFD",
                          borderRadius: 10,
                        }}
                      >
                        <CardTitle style={{ marginLeft: "0.75rem" }}>
                          Total amounts
                        </CardTitle>
                        <div
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <CardNumber>
                            {formatDollarAmount(campaignDetails.total_raised)}{" "}
                          </CardNumber>
                          <CardTag style={{ marginLeft: "1rem" }}>
                            pledged of{" "}
                            {formatDollarAmount(campaignDetails.goal)} goal
                          </CardTag>
                        </div>
                        <ProgressBar
                          variant="determinate"
                          value={
                            (100 * campaignDetails.total_raised) /
                            campaignDetails.goal
                          }
                        />
                      </Card>
                    </Grid>
                    <Grid item xs={11}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <CardTitle>Donation stats</CardTitle>
                        <IntervalSelect
                          defaultValue={donationStatsTimes[0].value}
                          onChange={(e) =>
                            setStatsTime(e.target.value as string)
                          }
                        >
                          {donationStatsTimes.map((time) => (
                            <MenuItem key={time.value} value={time.value}>
                              {time.label}
                            </MenuItem>
                          ))}
                        </IntervalSelect>
                      </div>
                      <Card
                        style={{
                          minHeight: "170px",
                          backgroundColor: "#FDFDFD",
                          borderRadius: 10,
                          marginTop: "0.3rem",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ width: "500px", height: "172px" }}>
                          <DonationChart
                            donationData={donationData}
                            donationCategories={donationCategories}
                          />
                        </div>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={3.5}>
                  <Card
                    style={{
                      backgroundColor: "#FDFDFD",
                      borderRadius: 10,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: "space-between",
                      padding: '1rem 1rem 0',
                      position: 'relative',
                    }}
                  >
                    <TopDonorsList
                      title="Total donors"
                      donors={mappedDonors}
                      showTotalDonors={true}
                      showTopDonorAvatar={true}
                      showTopDonorName={true}
                      showDownloadButton={true}
                    />
                  </Card>
                </Grid>
              </Grid>
              <div style={{ width: "98%", marginTop: "2rem" }}>
                <TransactionsTable transactions={transactionData} />
              </div>
            </Grid>
          </DetailContainer>
        </MainContainer>
      </CenterPageSection>
    </Sections>
  );
}
